















































































































































import type { PropType } from "vue"
import type { stadium_business } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name: "StadiumBusinessForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    addr    : { type: String, default: "" },
    form    : { type: Object as PropType<stadium_business> },
    correct : { type: Object, default() { return {} } },
    show    : { type: Object,
      default() {
        return {
          all                    : true,
          enterprise_name        : true,
          credit_code            : true,
          legal                  : true,
          principal              : true,
          publicity_material_addr: true,
        }
      }
    }
  },
  data() {
    return {
      area  : [] as string[],
      data  : {} as stadium_business,
      change: {} as any,
      rules : {
        enterprise_name        : { required: true, message: "营业执照名称不能为空", trigger: "blur" },
        credit_code            : { required: true, message: "统一社会信用代码不能为空", trigger: "blur" },
        legal_representative   : { required: true, message: "法人代表不能为空", trigger: "blur" },
        legal_phone            : { required: true, message: "电话不能为空", trigger: "blur" },
        principal_name         : { required: true, message: "经营负责人不能为空", trigger: "blur" },
        principal_phone        : { required: true, message: "电话不能为空", trigger: "blur" },
        publicity_material_addr: { required: true, message: "收件地址不能为空", trigger: "blur" },
      },
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const data = this.$deep_copy(this.form)
        this.data = data
      })
    },
    show_correct(key: string): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
        if (this.change.id && this.change.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    change_address(e: any) {
      if (e.target.checked) {
        this.data.publicity_material_addr = this.addr
      }
    },
    submit() {
      const form = this.$refs.form as any
      const params = this.$deep_copy(this.data)
      form.validate((valid: boolean) => {
        if (valid) {
          params.estimate_id = this.id
          this.$emit("modify", params)
        }
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          if (!this.correct.id) this.submit()
          this.change = this.$deep_copy(this.correct)
        })
      },
      deep   : true
    }
  }
})
